export default __webpack_public_path__ + "static/media/buzzer - inactive-1.b964a46a.png";